import moment from 'moment'

import http from '../../../lib/http'

export const CLINICAL_IMPRESSIONS = 'CLINICAL_IMPRESSIONS'
export const CLINICAL_IMPRESSIONS_SUCCESS = 'CLINICAL_IMPRESSIONS_SUCCESS'
export const CLINICAL_IMPRESSIONS_FAILURE = 'CLINICAL_IMPRESSIONS_FAILURE'
export const CLEAR_MORE_NARRATIVES = 'CLEAR_MORE_NARRATIVES'
export const MORE_NARRATIVES = 'MORE_NARRATIVES'
export const MORE_NARRATIVES_SUCCESS = 'MORE_NARRATIVES_SUCCESS'
export const MORE_NARRATIVES_FAILURE = 'MORE_NARRATIVES_FAILURE'

export const clearNarratives = () => ({
  type: CLEAR_MORE_NARRATIVES
})

function clinicalImpressions () {
  return {
    type: CLINICAL_IMPRESSIONS
  }
}

function success (d) {
  let data = []
  d.map(n => {
    data = data.concat(n.narratives.map(v => ({
      ...v,
      role: n.role
    })))
    return null
  })

  data.sort((i1, i2) => moment(i2.date).diff(moment(i1.date)))

  return {
    type: CLINICAL_IMPRESSIONS_SUCCESS,
    data
  }
}

function failure (error) {
  return {
    type: CLINICAL_IMPRESSIONS_FAILURE,
    error
  }
}

export const getNarratives = (id, clientName) => (dispatch, getState) => {
  let state = getState()
  clientName = clientName ?? state.globalVars?.params?.clientName

  dispatch(clinicalImpressions())

  return http
    .getRequest(`/patients/${id}/encounters/views/narratives`, {}, { clientName })
    .then(data => dispatch(success(data)))
    .catch(err => dispatch(failure(err)))
}
